import React from "react";
import Nicholas from "assets/Nicholas.png";

// form & validsation
import * as yup from "yup";
import { FormError, FormRadio, FormLabel } from "components";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { customClasses } from "styles";
import Slider from "@material-ui/core/Slider";

const marks = [
  {
    value: 0,
    label: "",
  },
  {
    value: 5000,
    label: "",
  },
  {
    value: 10000,
    label: "$10k",
  },
  {
    value: 20000,
    label: "",
  },
  {
    value: 50000,
    label: "$50k",
  },
  {
    value: 80000,
    label: "",
  },
  {
    value: 100000,
    label: "$100k",
  },
  {
    value: 200000,
    label: "$200k",
  },
  {
    value: 500000,
    label: "$500k",
  },
];

// schema
const Step12schema = yup.object().shape({
  financial: yup
    .object()
    .shape({
      if_overseas_property: yup
        .string("You must provide a value")
        .required("You must provide a value"),
      if_inheritance: yup.string().required("You must provide a value"),
      if_other_valuables: yup.string().required("You must provide a value"),
      // other_assets_totals: yup.string().required("You must provide a value"),
    })
    .required(),
});
export function Step13({ onSubmit, store }) {
  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: store,
    resolver: yupResolver(Step12schema),
  });

  function valuetext(value, name) {
    setValue(name, value);
    return `${value}°C`;
  }
  const handleData = (values) => {
    const copy_data = Object.assign({}, store.financial);
    const merger_current_values = { ...copy_data, ...values.financial };
    const mergeToStore = { ...store, financial: merger_current_values };
    onSubmit(mergeToStore);
  };

  return (
    <form id="divorce-form" onSubmit={handleSubmit(handleData)}>
      <section>
        <p className={customClasses.questionText}>
          Do you or{" "}
          {store?.user_details?.partner_first_name
            ? store?.user_details?.partner_first_name
            : "Your Ex-Partner"}{" "}
          have any of the following?
        </p>

        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor="financial.if_overseas_property"
            className={customClasses.questionText}
            error={errors?.financial?.if_overseas_property?.message}
          >
            Overseas Property
          </FormLabel>
          <article>
            <FormRadio
              setValue={setValue}
              value="Yes"
              name="financial.if_overseas_property"
              register={register}
            />
            <FormRadio
              setValue={setValue}
              value="No"
              name="financial.if_overseas_property"
              register={register}
            />
            <FormRadio
              setValue={setValue}
              value="Unsure"
              name="financial.if_overseas_property"
              register={register}
            />
          </article>
          <FormError error={errors.financial?.if_overseas_property?.message} />
        </section>

        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor="financial.if_inheritance"
            className={customClasses.questionText}
            error={errors?.financial?.if_inheritance?.message}
          >
            Expected Inheritance
          </FormLabel>
          <article>
            <FormRadio
              setValue={setValue}
              value="Yes"
              name="financial.if_inheritance"
              register={register}
            />
            <FormRadio
              setValue={setValue}
              value="No"
              name="financial.if_inheritance"
              register={register}
            />
            <FormRadio
              setValue={setValue}
              value="Unsure"
              name="financial.if_inheritance"
              register={register}
            />
          </article>
          <FormError error={errors.financial?.if_inheritance?.message} />
        </section>

        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor="financial.if_other_valuables"
            className={customClasses.questionText}
            error={errors?.financial?.if_other_valuables?.message}
          >
            Any other valuable assets
          </FormLabel>
          <article>
            <FormRadio
              setValue={setValue}
              value="Yes"
              name="financial.if_other_valuables"
              register={register}
            />
            <FormRadio
              setValue={setValue}
              value="No"
              name="financial.if_other_valuables"
              register={register}
            />
            <FormRadio
              setValue={setValue}
              value="Unsure"
              name="financial.if_other_valuables"
              register={register}
            />
          </article>
          <FormError error={errors.financial?.if_other_valuables?.message} />
        </section>

        {/* <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor="financial.other_assets_totals"
            className={customClasses.questionText}
            error={errors?.financial?.other_assets_totals?.message}
          >
            Approxima total values of these assets
          </FormLabel>

          <article>
            <Slider
              defaultValue={20}
              getAriaValueText={(value) =>
                valuetext(value, "financial.other_assets_totals")
              }
              aria-labelledby="discrete-slider-custom"
              step={9}
              valueLabelDisplay="auto"
              marks={marks}
              max={500000}
            />
          </article>
        </section> */}
      </section>
    </form>
  );
}
